"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var crystal_ball_svg_1 = __importDefault(require("../../../../../../assets/rubyJackpot/icons/crystal_ball.svg"));
var slot_machine_svg_1 = __importDefault(require("../../../../../../assets/rubyJackpot/icons/slot-machine.svg"));
var trophy_svg_1 = __importDefault(require("../../../../../../assets/rubyJackpot/icons/trophy.svg"));
var ISliders_1 = require("../../../interfaces/ISliders");
var FeelingLuckyButton_1 = __importDefault(require("../../GamesContainer/FeelingLuckyButton"));
var SwitchButtons = function (_a) {
    var currentSlider = _a.currentSlider, setCurrentSlider = _a.setCurrentSlider, getRandomGame = _a.getRandomGame;
    var _b = (0, react_1.useState)(false), crystalExpanded = _b[0], setCrystalExpanded = _b[1];
    var expand = function () {
        if (crystalExpanded) {
            getRandomGame();
        }
        setCrystalExpanded(function (crystal) { return !crystal; });
    };
    var toggleCrystalExpand = function (slider) {
        setCurrentSlider(slider);
        if (crystalExpanded)
            setCrystalExpanded(false);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "switch-container" }, { children: [(0, jsx_runtime_1.jsxs)("section", __assign({ className: "switch-container-grouped" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ onClick: function () { return toggleCrystalExpand(ISliders_1.SliderTypes.ParticipatingGames); }, className: (0, clsx_1.default)("switch-container-button", currentSlider === ISliders_1.SliderTypes.ParticipatingGames && "switch-container-button-selected") }, { children: (0, jsx_runtime_1.jsx)("img", { src: slot_machine_svg_1.default, alt: "slot-machine" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ onClick: function () { return toggleCrystalExpand(ISliders_1.SliderTypes.LatestWinners); }, className: (0, clsx_1.default)("switch-container-button", currentSlider === ISliders_1.SliderTypes.LatestWinners && "switch-container-button-selected") }, { children: (0, jsx_runtime_1.jsx)("img", { src: trophy_svg_1.default, alt: "trophy" }) }))] })), !crystalExpanded && (0, jsx_runtime_1.jsx)("div", __assign({ onClick: expand, className: "switch-container-button show" }, { children: (0, jsx_runtime_1.jsx)("img", { src: crystal_ball_svg_1.default, alt: "crystal_ball" }) })), crystalExpanded && (0, jsx_runtime_1.jsx)(FeelingLuckyButton_1.default, { hide: !crystalExpanded, getRandomGame: expand })] })));
};
exports.default = SwitchButtons;
